import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { CHECKBOX_RADIUS_PX } from 'theme/shape';

const CheckboxUnchecked = (props: SvgIconProps) => {
    return (
        <SvgIcon
            viewBox="0 0 18 18"
            sx={{ borderRadius: CHECKBOX_RADIUS_PX, border: '1px solid currentColor' }}
            {...props}>
            <rect width="17.5" height="17.5" x="0.5" y="0.5" fill="transparent" rx="6" />
        </SvgIcon>
    );
};

export default CheckboxUnchecked;
